/**
 * @desc shipped
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.OrderApplyOperationRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/outPlanMaster/outPlan/shipped`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
